import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { DetailLinksModule } from 'src/app/common-components/detail-links/detail-links.module';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { LcsChipMultiSelectModule } from 'src/app/common-components/multi-select/multi-select.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { CallLogsRegisterModule } from '../call-logs-register/call-logs-register.module';
import { ClosedExceptionsModule } from '../closed-exceptions/closed-exceptions.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { ScheduleHoursModule } from '../schedule-hours/schedule-hours.module';
import { ExtensionGroupDetailComponent } from './containers/extension-group-detail.component';
import { ExtensionGroupDetailEffects } from './state/extension-group-detail.effects';
import * as fromExtensionGroupDetail from './state/extension-group-detail.reducer';
import { ExtensionGroupDetailViewComponent } from './views/extension-group-detail-view.component';
@NgModule({
   declarations: [ExtensionGroupDetailViewComponent, ExtensionGroupDetailComponent],
   exports: [ExtensionGroupDetailComponent],
   imports: [
      LcsChipMultiSelectModule,
      LcsMultiSelectModule,
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      FormatPhoneNumbersPipeModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      LcsAdvancedMultiSelectModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      LcsCallStatePipeModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      EntitySelectModule,
      MatTabsModule,
      RouterModule,
      DetailLinksModule,
      UpdateDetailsModule,
      ScrollingModule,
      MatDividerModule,
      ErrorPageModule,
      StoreModule.forFeature(fromExtensionGroupDetail.extensionGroupDetailFeatureKey, fromExtensionGroupDetail.reducer),
      EffectsModule.forFeature([ExtensionGroupDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
      ScheduleHoursModule,
      ClosedExceptionsModule,
      CallLogsRegisterModule,
      ResizeOnTabChangeDirectiveModule,
   ],
})
export class ExtensionGroupDetailModule {}
